/**
 * Returns if an account lob has full, partial, or no outage
 *
 * @param accountLOB Enum value representing a type of account
 * @returns Returns outage state of AccountLOB
 */
const getOutage = (accountLOB) => {
    return (domain) => {
        if (domain == null)
            return "none";
        const { errors: allErrors = [] } = domain;
        const hasFullOutage = allErrors.some(({ code }) => [
            `${accountLOB}_FAILURE`,
            "CCAPI_AAA_FAILURE",
            "CONSUMER_FAILURE",
        ].includes(String(code).toUpperCase()));
        const hasPartialOutage = allErrors.some(({ code }) => String(code).toUpperCase() === `${accountLOB}_PARTIAL_FAILURE`);
        if (hasFullOutage) {
            return "full";
        }
        if (hasPartialOutage) {
            return "partial";
        }
        return "none";
    };
};
/**
 * Returns outage state for auto customers
 */
export const getAutoOutage = getOutage("AUTO");
/**
 * Returns outage state for deposit customers
 */
export const getDepositOutage = getOutage("DEPOSIT");
/**
 * Returns outage state for homeloan customers
 */
export const getHomeLoanOutage = getOutage("HOMELOAN");
/**
 * Returns outage state for invest customers
 */
export const getInvestOutage = getOutage("INVEST");
/**
 * Returns outage state for wealth customers
 */
export const getWealthOutage = getOutage("WEALTH");
/**
 * Returns outage state for mortage customers
 */
export const getMortgageOutage = getOutage("MORTGAGE");
/**
 * Returns outage state for credit card customers
 */
export const getCreditCardOutage = getOutage("CREDITCARD");
/**
 * Find outages that are AccountLOB specific
 *
 * @param domain AccountsDomain that will provide data to retrieve outage status
 * @returns Return array of outage status based on AccountLOB
 */
export const getOutages = (domain) => {
    return {
        AUTO: getAutoOutage(domain),
        DEPOSIT: getDepositOutage(domain),
        HOMELOAN: getHomeLoanOutage(domain),
        INVEST: getInvestOutage(domain),
        WEALTH: getWealthOutage(domain),
        MORTGAGE: getMortgageOutage(domain),
        CC: getCreditCardOutage(domain),
    };
};
//# sourceMappingURL=outage.js.map